import React from 'react'
import PropTypes from 'prop-types'
import { CTA } from 'goustouicomponents/dist/CTA'
import css from './DepartmentFilters.module.css'
import { pushWindowHistory } from '../../../utils/pushWindowHistory'

const onClick = (setSelectedDepartment, selectedDepartment) => {
  setSelectedDepartment(selectedDepartment)
  pushWindowHistory('department', selectedDepartment)
}

const DepartmentFilters = ({
  departments,
  setSelectedDepartment,
  selectedDepartment,
}) => (
  <div className={css.filtersWrapper}>
    {departments.map((department) => {
      const { id, label, availableJobs } = department

      return (
        <div key={id} className={css.filterCTA}>
          <CTA
            onClick={() => onClick(setSelectedDepartment, id)}
            size="small"
            variant={selectedDepartment === id ? 'primary' : 'secondary'}
          >
            {`${label} (${availableJobs})`}
          </CTA>
        </div>
      )
    })}
  </div>
)

DepartmentFilters.propTypes = {
  departments: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
    label: PropTypes.string,
    availableJobs: PropTypes.number,
  })).isRequired,
  setSelectedDepartment: PropTypes.func.isRequired,
  selectedDepartment: PropTypes.number.isRequired,
}

export { DepartmentFilters }
